module.exports = __webpack_public_path__ + "communication.png?b51b686bbd7a3d4c02b55b2fed0b190b";


//////////////////
// WEBPACK FOOTER
// ./src/images/communication.png
// module id = 102
// module chunks = 27